export default __webpack_public_path__ + "static/media/iot3.9ce71d9d.jpg";